export function detailEntityMatchesRoute<T>(
  entity: T | null | undefined,
  routeId: string | undefined,
  matchesRoute: (entity: T, routeId: string) => boolean,
): entity is T {
  return Boolean(entity && routeId && matchesRoute(entity, routeId))
}

export function keepDetailEntityForRoute<T>(
  entity: T | null | undefined,
  routeId: string | undefined,
  matchesRoute: (entity: T, routeId: string) => boolean,
): T | null {
  return detailEntityMatchesRoute(entity, routeId, matchesRoute) ? entity : null
}

export function isDetailLoadErrorFatal<T>(
  entity: T | null | undefined,
  routeId: string | undefined,
  matchesRoute: (entity: T, routeId: string) => boolean,
): boolean {
  return !detailEntityMatchesRoute(entity, routeId, matchesRoute)
}
